import { supabase } from '../../../services/supabase';
import { TaggregatedCheckIns, Tleaves } from '../../../types/analyticsTypes';

import { getLeaves } from './getLeaves';

export const getCheckInsData = async (
  startDate: string,
  endDate: string,
): Promise<{
  aggregatedCheckIns: TaggregatedCheckIns[];
  leaves: Tleaves[];
}> => {
  let checkInsData: TaggregatedCheckIns[] = [];
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1))
    .toISOString()
    .split('T')[0];
  const today = new Date().toISOString().split('T')[0];
  const now = new Date().toISOString().split('T')[1].substring(0, 5);
  let sequence = 0;
  if (now >= '12:30') sequence = 2;
  else if (now >= '08:30') sequence = 1;
  const isCurrentPeriod = endDate === today;

  if (!isCurrentPeriod || sequence === 2) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { data: totalData, error } = await supabase.rpc(
      'get_team_check_ins',
      {
        start_date: startDate,
        end_date: endDate,
      },
    );

    if (error) throw new Error('Error fetching check-ins data');
    if (totalData) checkInsData = totalData as TaggregatedCheckIns[];
  } else if (isCurrentPeriod) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { data, error: aggregatedCheckInsError } = await supabase.rpc(
      'get_team_check_ins',
      {
        start_date: startDate,
        end_date: yesterday,
      },
    );

    if (aggregatedCheckInsError)
      throw new Error('Error fetching aggregated check-ins');
    if (data) checkInsData = data as TaggregatedCheckIns[];

    if (isCurrentPeriod && sequence === 1) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const { data: morningData, error: todayError } = await supabase.rpc(
        'get_team_morning_check_ins',
        {
          date: today,
        },
      );

      if (todayError) throw new Error('Error fetching morning check-ins');
      if (!morningData) return { aggregatedCheckIns: checkInsData, leaves: [] };

      checkInsData = checkInsData.map((item: TaggregatedCheckIns) => {
        const morningItem = (morningData as TaggregatedCheckIns[]).find(
          (morning: TaggregatedCheckIns) =>
            morning.user_id === item.user_id &&
            (item.daily_sequence === null || item.daily_sequence === 1),
        );
        return morningItem
          ? {
              ...item,
              daily_sequence:
                morningItem?.daily_sequence || item.daily_sequence,
              check_in_count:
                (morningItem?.check_in_count || 0) + (item.check_in_count || 0),
            }
          : item;
      });
    }
  }
  if (startDate > endDate) {
    return {
      aggregatedCheckIns: checkInsData,
      leaves: [],
    };
  }
  const { leaves, error: leavesError } = await getLeaves(startDate, endDate);
  if (leavesError) {
    throw new Error('Error fetching data');
  }
  return {
    aggregatedCheckIns: checkInsData,
    leaves,
  };
};
